export default __webpack_public_path__ + "static/media/calais@2x.a1d1bbe6.jpg";